import { permissionGroup } from '../common/permissionGroup';

const groupedPermissions = (list) => {
  const temp = {};
  list.forEach((item) => {
    if (item.group !== permissionGroup.ADMIN) temp[item.group] = [...temp[item.group] || [], item];
  });
  return temp;
};
export default groupedPermissions;
